// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"ImageModal_imageContainer__E4UCF","image":"ImageModal_image__2TDNi"};